// 默认利用axios的cancelToken进行防重复提交。
// 如需允许多个提交同时发出。则需要在请求配置config中增加 neverCancel 属性，并设置为true

import axios from 'axios';
// import store from '../store/index';
// import { getSessionId } from '@/utils/auth';
import router from '../router';
import { message } from 'ant-design-vue';
/* 防止重复提交，利用axios的cancelToken */
let pending: any[] = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const CancelToken: any = axios.CancelToken;

const removePending: any = (config: any, f: any) => {
  // 获取请求的url
  const flagUrl = config.url;
  // 判断该请求是否在请求队列中
  if (pending.indexOf(flagUrl) !== -1) {
    // 如果在请求中，并存在f,f即axios提供的取消函数
    if (f) {
      f('取消重复请求'); // 执行取消操作
    } else {
      pending.splice(pending.indexOf(flagUrl), 1); // 把这条记录从数组中移除
    }
  } else {
    // 如果不存在在请求队列中，加入队列
    if (f) {
      pending.push(flagUrl);
    }
  }
};
/* 创建axios实例 */
const service: any = axios.create({
  timeout: 1000 * 60 * 2, // 请求超时时间
});
const myVersion = '1.1.1';
// 在main.js设置全局的请求次数，请求的间隙
service.defaults.retry = 4;
service.defaults.retryDelay = 1000;
/* request拦截器 */
service.interceptors.request.use((config: any) => {
  // neverCancel 配置项，允许多个请求
  if (!config.neverCancel) {
    // 生成cancelToken
    config.cancelToken = new CancelToken((c: any) => {
      removePending(config, c);
    });
  }
  if (config.method === 'post') {
    config.data = {
      ...config.data,
      version: myVersion,
    };
  } else if (config.method === 'get') {
    config.params = {
      version: myVersion,
      ...config.params,
    };
  }
  // 在这里可以统一修改请求头，例如 加入 用户 token 等操作
  //   if (store.getters.sessionId) {
  //     config.headers['X-SessionId'] = getSessionId(); // 让每个请求携带token--['X-Token']为自定义key
  //   }
  return config;
}, (error: any) => {
  Promise.reject(error);
});

/* respone拦截器 */
service.interceptors.response.use(
  (response: any) => {
    // console.log(33);
    // window.location.reload();
    // 移除队列中的该请求，注意这时候没有传第二个参数f
    removePending(response.config);
    // 获取返回数据，并处理。按自己业务需求修改。下面只是个demo
    const res = response.data;
    if (res.code === 401) {
      router.replace({
        path: '/login',
      });
      return Promise.reject('请重新登录');
    } else if (res.code === 10) {
      message.warning(res.msg);
    } else {
      return response;
    }
  }, (error: any) => {
    // 异常处理
    console.log(error);
    pending = [];
    if (error.message === '取消重复请求') {
      return Promise.reject(error);
    }
    return Promise.reject(error);
});
service.interceptors.response.use( undefined, function axiosRetryInterceptor( err: any ) {
  const config = err.config;
  // If config does not exist or the retry option is not set, reject
  // 如果配置不存在或未设置重试选项，则返回错误信息
  if ( !config || !config.retry ) {
    return Promise.reject( err );
  }
  // Set the variable for keeping track of the retry count
  // 设置变量即跟踪重试次数
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  // 检查我们是否已经超过了总重试次数
  if ( config.__retryCount >= config.retry) {
    // Reject with the error
    // 返回错误信息
    return Promise.reject( err );
  }

  // Increase the retry count
  // 重试次数加1
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  // 创建延时器等待发送重试请求
  const backoff = new Promise((resolve) =>  {
    setTimeout(() => {
      resolve('reSend');
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  // 返回调用AXIOS来重试请求
  return backoff.then(() => {
    return axios(config);
  });
});

export default service;
